<template>
  <div
    style="
      overflow-x: hidden;
      overflow-y: hidden;
      padding-right: 0px;
      padding-left: 0px;
    "
    id="app"
    class="container"
  >
    <nav-bar></nav-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import NavBar from "./components/NavBar.vue";
import Cardapio from "./services/cardapio";
import store from "./store/index.js";

export default {
  name: "app",
  components: {
    NavBar,
  },
  data() {
    return {};
  },
};
</script>
